import { render, staticRenderFns } from "./coupon-list.vue?vue&type=template&id=6b0065c0&scoped=true&"
import script from "./coupon-list.vue?vue&type=script&lang=js&"
export * from "./coupon-list.vue?vue&type=script&lang=js&"
import style0 from "./coupon-list.vue?vue&type=style&index=0&id=6b0065c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0065c0",
  null
  
)

export default component.exports